import { useMutation, useQuery } from "react-query";

import { formatterGetMap } from "./formatter";
import {
    createMap,
    deleteMap,
    getAllMaps,
    getMapById,
    updateMap,
} from "./services";
import { Type_Map } from "./types";

export const useGetMap = (mapId: number) => {
    return useQuery({
        queryKey: ["map", mapId],
        queryFn: () => getMapById(mapId),
        select: (data) => {
            if (!data?.success || !data?.data) {
                throw new Error("Wrong format data: useGetMap");
            }
            return formatterGetMap(data.data);
        },
        onError: (err: any) => {
            return err;
        },
    });
};

export const useGetAllMaps = () => {
    return useQuery({
        queryKey: ["maps"],
        queryFn: () => getAllMaps(),
        select: (data) => {
            if (!data?.success || !data?.data) {
                throw new Error("Wrong format data: useGetMap");
            }
            return data.data.map(formatterGetMap);
        },
        onError: (err: any) => {
            return err;
        },
    });
};

export const mutationCreateMap = () => {
    return useMutation({
        mutationFn: (body: Partial<Type_Map>) => createMap(body),
        onSuccess: async (data) => {
            if (!data?.success || !data) {
                throw new Error("Wrong format data: mutationCreateMap");
            }
        },
        onError: (err: any) => {
            console.debug("ERROR mutationCreateMap", err);
            return err;
        },
    });
};

export const mutationUpdateMap = () => {
    return useMutation({
        mutationFn: async ({
            mapId,
            body,
        }: {
            mapId: number;
            body: Partial<Type_Map>;
        }) => updateMap(mapId, body),
        onSuccess: async (data) => {
            if (!data?.success || !data) {
                throw new Error("Wrong format data: mutationUpdateMap");
            }
        },
        onError: (err: any) => {
            console.error("Error in mutationUpdateMap:", err);
            return err;
        },
    });
};

export const mutationDeleteMap = () => {
    return useMutation({
        mutationFn: (id: number) => deleteMap(id),
        onSuccess: async (data) => {
            if (!data?.success || !data) {
                throw new Error("Wrong format data: mutationDeleteMap");
            }
        },
        onError: (err: any) => {
            console.debug("ERROR mutationDeleteMap", err);
            return err;
        },
    });
};
